import React, { useState, useEffect, useCallback } from 'react';
import { string } from 'prop-types';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { params, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { SEOPlaceholder } from './SEOPlaceholder.component';
import { LinkSets } from './LinkSets';
import './emt-links.scss';

const SeoLinksComponent = ({ path }) => {

  let linkSets = [];
  let headerLocation = 'Explore More on homedepot.com';

  const defaultRender = () => {
    return null;
  };

  const pathname = path.replace(/render-\w+\//, '');
  const options = {
    ssr: true,
    variables: { path: pathname }
  };

  const { loading, error, data } = useDataModel('seoLinks', options);

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('seo-links.ready'); }, []);

  const [showMore, setOverlay] = useState(false);
  const toggleOverlay = useCallback(() => {
    setOverlay((seeMore) => !seeMore);
  }, []);

  if (!path) return defaultRender();

  if (loading) {
    return (
      <SEOPlaceholder
        color="#E0E0E0"
        showLoadingAnimation
      />
    );
  }

  if ((error && !data) || !data?.seoLinks) {
    return null;
  }

  try {
    let seoLinks = JSON.parse(data.seoLinks);
    linkSets = seoLinks?.sets || [];
    headerLocation = seoLinks?.heading || 'Explore More on homedepot.com';
  } catch (err) {
    return defaultRender();
  }

  if (linkSets.length === 0) {
    return defaultRender();
  }
  return (
    <div className="col__12-12">
      <div className={
        showMore ? 'emt-links' : 'emt-links collapsed'
      }
      >
        <h2 className="emt-links-heading">{headerLocation}</h2>
        <LinkSets sets={linkSets} />
        <div className="emt-links__more__overlay">
          <img
            src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
            alt="more link"
            className="emt-links__more__icon"
            height="auto"
            width="auto"
          />
          <button className="emt-links__more__toggle" href="#" onClick={toggleOverlay} type="button">
            <span>{showMore ? 'View Less' : 'View More'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

SeoLinksComponent.displayName = 'SeoLinks';

const dataModel = {
  seoLinks: params({ path: stringType() }).string()
};

const propTypes = {
  path: string.isRequired
};
SeoLinksComponent.propTypes = propTypes;

const HydratedSEOLinks = withHydrator({
  id: 'seo-links',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (
    <SEOPlaceholder
      color="#E0E0E0"
      showLoadingAnimation
    />
  )
}, SeoLinksComponent);
const DynamicSeoLinks = withDynamicComponent(HydratedSEOLinks);
const SeoLinksLayoutGroup = withLayoutGroup({ name: 'seo-links' }, DynamicSeoLinks);
export const SeoLinks = SeoLinksLayoutGroup;

SeoLinks.propTypes = propTypes;
SeoLinks.dataModel = dataModel;
